import { initImageZoom } from "./imageZoom";
import { initMediaGallery } from "./mediaGallery";
var slider;
var thumbSlider;

/**
 * Takes a price in cents and returns a formatted money string with a
 * dollar sign and two decimal places.
 * @param price
 * @returns The function `convertToMoney` takes a price as input, divides it by 100, and returns a
 * string with the price formatted as a currency with two decimal places. If the price is less than or
 * equal to 0, an empty string is returned.
 */
var convertToMoney = function convertToMoney(price) {
  if (price <= 0) {
    return '';
  }
  var money = price / 100;
  return "$".concat(money.toFixed(2));
};

/**
 * Synchronizes radio button selections between a sticky element and the
 * main product element based on the options selected.
 * @param variantSelected
 */
var syncStickyATC = function syncStickyATC(variantSelected) {
  var sticky = document.querySelector('.sticky-atc');
  if (!sticky) {
    return;
  }
  var mainProduct = document.querySelector('.main-product');
  sticky.querySelectorAll('input[type="radio"]').forEach(function (item) {
    if (variantSelected.options.includes(item.value)) {
      item.click();
    }
  });
  mainProduct.querySelectorAll('input[type="radio"]').forEach(function (item) {
    if (variantSelected.options.includes(item.value)) {
      item.click();
    }
  });
};
var modifyImgTag = function modifyImgTag(elm, source) {
  elm.src = source.src + '&width=316';
  elm.dataset.image = source.src + '&width=551';
};
var updateProductSizes = function updateProductSizes(colorSelected) {
  var variants = document.querySelector("[data-product-variants]");
  variants = JSON.parse(variants.innerText).filter(function (el) {
    return el.option1.toLowerCase() === colorSelected.value.toLowerCase();
  });
  var sizeSelectors = document.querySelectorAll("input[data-type='size']");
  sizeSelectors.forEach(function (item) {
    var actualSize = variants.find(function (el) {
      return el.option2.toLowerCase() === item.value.toLowerCase();
    });
    var labelSize = document.querySelector(".btn-size[data-value=\"".concat(item.value, "\"]"));
    if (actualSize && actualSize.available) {
      item.disabled = false;
      labelSize.classList.remove("disabled");
    } else {
      item.disabled = true;
      labelSize.classList.add("disabled");
    }
  });
};
var updateProductThumbs = function updateProductThumbs(elm, imageAlt) {
  var variantThumbs = elm.querySelectorAll('img');
  variantThumbs.forEach(function (img) {
    if (img.alt !== imageAlt) {
      img.closest(".swiper-slide").classList.add('hidden');
    } else {
      img.closest(".swiper-slide").classList.remove('hidden');
    }
  });
  thumbSlider.update();
};
var updateProductMobileSlider = function updateProductMobileSlider(elm, imageAlt) {
  var variantThumbs = elm.querySelectorAll('img');
  console.log("exec", variantThumbs);
  variantThumbs.forEach(function (img) {
    console.log(img.alt, imageAlt);
    if (img.alt !== imageAlt) {
      img.closest(".swiper-slide").classList.add('hidden');
    } else {
      img.closest(".swiper-slide").classList.remove('hidden');
    }
  });
  slider.update();
  thumbSlider.update();
};

/**
 * Updates the src and dataset.image attributes of img elements
 * within a given element using an array of images.
 * @param elm - DOM Element
 * @param images - Array
 */
var updateProductMediaImg = function updateProductMediaImg(elm, images, type) {
  var variantMedia = elm.querySelectorAll('img');
  switch (type) {
    case 'single':
      variantMedia[0].src = images[0].src + '&width=551';
      variantMedia[0].closest('.image-zoom-js').style.setProperty('--url', "url(".concat(images[0].src, ")"));
      break;
    case 'gallery':
      if (variantMedia.length == images.length) {
        images.forEach(function (image, index) {
          modifyImgTag(variantMedia[index], image);
        });
      } else if (variantMedia.length < images.length) {
        images.forEach(function (image, index) {
          if (!variantMedia[index]) {
            var img = document.createElement('img');
            modifyImgTag(img, image);
            elm.appendChild(img);
          } else {
            modifyImgTag(variantMedia[index], image);
          }
        });
      } else {
        variantMedia.forEach(function (img, index) {
          if (!images[index]) {
            img.remove();
          } else {
            modifyImgTag(img, images[index]);
          }
        });
      }
      break;
  }
};
var updatePDPGallery = function updatePDPGallery(elm, images, type) {
  elm.innerHTML = "";
  switch (type) {
    case 'slider':
      var qvslider;
      if (elm.closest('.quick-view-slider')) {
        qvslider = new Swiper(elm.closest('.quick-view-slider'), {
          slidesPerView: 1,
          navigation: {
            nextEl: '.quick-view-slider-button-next',
            prevEl: '.quick-view-slider-button-prev'
          }
        });
      }
      images.forEach(function (image) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        if (image.media_type == "image") {
          var media = document.createElement('img');
          media.src = image.src + '&width=551';
          slide.classList.add('image-zoom-js');
          slide.style.setProperty('--url', "url(".concat(image.src, ")"));
          slide.style.setProperty('--display', 'none');
          slide.appendChild(media);
        }
        if (image.media_type == "video") {
          var _media = document.createElement('video');
          _media.src = image.sources[0].url;
          _media.autoplay = true;
          _media.muted = true;
          _media.loop = true;
          _media.dataset.image = image.sources[0].url;
          slide.appendChild(_media);
        }
        if (qvslider) {
          qvslider.appendSlide(slide);
        } else {
          slider.appendSlide(slide);
        }
      });
      initImageZoom();
      break;
    case 'gallery':
      images.forEach(function (image) {
        var thumb = document.createElement('div');
        thumb.className = 'media-gallery__thumb';
        if (image.media_type == "image") {
          var media = document.createElement('img');
          media.className = 'resource';
          media.dataset.type = image.media_type;
          media.src = image.src + '&width=316';
          media.dataset.image = image.src + '&width=551';
          thumb.appendChild(media);
        }
        if (image.media_type == "video") {
          var _media2 = document.createElement('video');
          _media2.className = 'resource';
          _media2.dataset.type = image.media_type;
          _media2.src = image.sources[0].url;
          _media2.dataset.image = image.sources[0].url;
          thumb.appendChild(_media2);
        }
        elm.appendChild(thumb);
      });
      initMediaGallery();
      break;
  }
};

/**
 * Updates the product media displayed on a webpage based on the
 * variant selected.
 * @param product
 * @param variantSelected
 */
var updateProductMedia = function updateProductMedia(product, variantSelected) {
  var productMedia = JSON.parse(product.querySelector('[data-product-media]').textContent);
  var imageAlt = variantSelected.featured_image.alt;
  var images = productMedia.filter(function (_ref) {
    var alt = _ref.alt;
    return alt === imageAlt;
  });

  // PDP Product Media Gallery
  var mediaGallery = product.querySelector('.media-js-gallery');
  var mediaGallerySingle = product.querySelector('.media-js-gallery-single');
  if (mediaGallery) {
    updatePDPGallery(mediaGallery, images, 'gallery');
    updateProductMediaImg(mediaGallerySingle, images, 'single');
  }

  // Complete the look - Single Image
  var media = product.querySelector('.product-js-media');
  if (media) {
    updateProductMediaImg(media, images, 'gallery');
  }

  // PDP Mobile Thumbs 
  var mobileThumbs = product.querySelector('.media-slider-thumbs');
  var mediaSlider = product.querySelector('.media-js-slider');
  if (mobileThumbs) {
    updateProductThumbs(mobileThumbs, imageAlt);
    updateProductMobileSlider(mediaSlider, imageAlt);
  } else if (mediaSlider) {
    updatePDPGallery(mediaSlider, images, 'slider');
  }
};

/**
 * Updates the product information displayed on a webpage based on the
 * selected variant.
 * @param product
 * @param variantSelected
 */
var updateProductInfo = function updateProductInfo(product, variantSelected) {
  product.querySelector('input[name="id"]').value = variantSelected === null || variantSelected === void 0 ? void 0 : variantSelected.id;
  product.querySelector('.product-js-price').textContent = convertToMoney(variantSelected === null || variantSelected === void 0 ? void 0 : variantSelected.price);
  product.querySelector('.product-js-compare-at').textContent = convertToMoney(variantSelected === null || variantSelected === void 0 ? void 0 : variantSelected.compare_at_price);
  var btnAddToCart = product.querySelector('[type="submit"]');
  var btnNotifyMe = product.querySelector('.BIS_trigger') || product.querySelector('#BIS_trigger');
  console.log(btnNotifyMe);
  if (variantSelected.available) {
    btnAddToCart.removeAttribute("disabled");
    btnAddToCart.style.setProperty('display', 'flex');
    btnAddToCart.textContent = btnAddToCart.dataset.add;
    if (btnNotifyMe) {
      btnNotifyMe.style.setProperty('display', 'none');
    }
  } else {
    btnAddToCart.setAttribute('disabled', 'disabled');
    btnAddToCart.style.setProperty('display', 'none');
    btnAddToCart.textContent = btnAddToCart.dataset.out;
    if (btnNotifyMe) {
      btnNotifyMe.style.setProperty('display', 'flex');
      btnNotifyMe.dataset.variantId = variantSelected === null || variantSelected === void 0 ? void 0 : variantSelected.id;
    }
  }
};

/**
 * Retrieves the selected product variant based on the chosen
 * selectors and product information.
 * @param selectors - Selectors is an array of HTML input elements representing the options that a user
 * has selected for a product
 * @param product
 * @returns returns the selected variant based on the selectors
 * provided and the product's available variants.
 */
var getProductVariant = function getProductVariant(selectors, product) {
  var variants = JSON.parse(product.querySelector('[data-product-variants]').textContent);
  var selectorsSelected = [];
  selectors.forEach(function (selector) {
    if (selector.checked) {
      selectorsSelected.push(selector.value);
    }
  });
  var variantSelected = variants.find(function (item) {
    return item.options.length === selectorsSelected.length && item.options.every(function (option, index) {
      return option === selectorsSelected[index];
    });
  });
  return variantSelected;
};

/**
 * Updates product information, media, and synchronizes the
 * sticky add-to-cart button based on the selected product variant.
 * @param variantSelector
 */
var handleProductVariantSelected = function handleProductVariantSelected(variantSelector) {
  var product = variantSelector.closest('.product-js');
  var selectors = product.querySelectorAll('input[type="radio"]');
  var colorSelected = product.querySelector('input[data-type="color"]:checked');
  var variantSelected = getProductVariant(selectors, product);
  if (colorSelected) {
    updateProductSizes(colorSelected);
  }
  updateProductInfo(product, variantSelected);
  updateProductMedia(product, variantSelected);
  syncStickyATC(variantSelected);
};

/**
 * Selects all radio input elements within a specific class and adds an
 * event listener to each to handle when a variant is selected.
 */
var initProductVariants = function initProductVariants() {
  // slider = new Swiper('.media-slider', {
  //     slidesPerView: 1,
  //     scrollbar: {
  //       el: '.media-slider-scrollbar',
  //       draggable: true
  //     }
  // })

  thumbSlider = new Swiper('.media-slider-thumbs', {
    loop: true,
    spaceBetween: 5,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true
  });
  slider = new Swiper('.media-slider', {
    slidesPerView: 1,
    scrollbar: {
      el: '.media-slider-scrollbar',
      draggable: true
    },
    thumbs: {
      swiper: thumbSlider
    }
  });
  var variantSelectors = document.querySelectorAll('.product-js input[type="radio"]');
  variantSelectors.forEach(function (variantSelector) {
    variantSelector.addEventListener('change', function () {
      handleProductVariantSelected(variantSelector);
    });
  });
};
export { initProductVariants };